import React from 'react'
import { inject, observer } from "mobx-react"

const SuggestionListPreview = observer(({ store, field, instance }) => {
  const { suggestionListId } = field
  const { suggestionLists } = store

  // Only show in builder mode
  if(!store.buildable) {
    return null
  }

  if(!field.suggestionListId) {
    return null
  }

  const suggestionList = suggestionLists.find(s => s.id == suggestionListId)

  if(!suggestionList) {
    return null
  }

  return (
    <div className="font-style-italic">Choosing from the `{suggestionList.title}` list</div>
  )
})

export default inject("store")(SuggestionListPreview)
